import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalCheck: {
    id: 'onboarding.check',
    defaultMessage: 'Do not show this tutorial the next time I log in.',
    description: 'Check button of carousel modal',
  },
  export: {
    id: 'onboarding.export',
    defaultMessage:
      'By clicking on the export PDF button, you can choose between exporting transactions (list of transactions over the whole period or over a given interval) or exporting the whole file (all data visible in the dashboard for this file).',
    description: 'PDF export',
  },
  modificationsTransactionCategories: {
    id: 'onboarding.modifications_transaction_categories',
    defaultMessage:
      'By clicking on a budget row in the Transaction Scoreboard on the Analysis page or on a category in the transaction list (Transactions page), you can change the category of a group of transactions. Once this new category is validated, the analysis of the file will automatically update to take into consideration this change.',
    description: 'Modification of transaction categories',
  },
  filterAccounts: {
    id: 'onboarding.filter_accounts',
    defaultMessage:
      'You can filter the bank history and the transaction table by selecting and deselecting one or more accounts in the list. This filter can be combined with the other filters.',
    description: 'Filters by account',
  },
  filterDates: {
    id: 'onboarding.filter_dates',
    defaultMessage:
      'You can filter the bank history and transaction table by selecting and deselecting one or more accounts in the list. You can filter the transaction list table by date by clicking on the desired date in the "Bank History" graph, or by period by selecting the desired date range in this same graph. This filter can be combined with the other filter',
    description: 'Filters by Date and Period',
  },
  filterByCategories: {
    id: 'onboarding.filter_categories',
    defaultMessage:
      'You can also filter the list of transactions by transaction categories and/or payment types from the "Filters" button located to the right of the search field, above the table. These filters can be combined with the other filters.',
    description: 'Filters by Transaction Categories and Payment Types',
  },
  transactionSearch: {
    id: 'onboarding.transaction_search',
    defaultMessage:
      'The search field above the table allows you to restrict the list of transactions to a specific label, category, type or amount. This filter can be combined with the other filters.',
    description: 'Transaction Search',
  },
  addNotes: {
    id: 'onboarding.add_notes',
    defaultMessage:
      'By clicking on the "pencil" icon to the right of a transaction row, you can annotate that transaction and save the note. Transaction rows that contain a note will display a red dot on the "pencil" icon for easy retrieval.',
    description: 'Add a note',
  },
  titleExport: {
    id: 'onboarding.title_export',
    defaultMessage: 'PDF export',
    description: 'Title of Export',
  },
  titleModificationsTransactionCategories: {
    id: 'onboarding.title_modifications_transaction_categories',
    defaultMessage: 'Modification of transaction categories',
    description: 'Title of modifications',
  },
  titleFilterAccounts: {
    id: 'onboarding.title_filter_accounts',
    defaultMessage: 'Filters by account',
    description: 'Title of filter by accounts',
  },
  titleFilterDates: {
    id: 'onboarding.title_filter_dates',
    defaultMessage: 'Filters by Date and Period',
    description: 'Title of filter by dates',
  },
  titleFilterByCategories: {
    id: 'onboarding.title_filter_categories',
    defaultMessage: 'Filters by Transaction Categories and Payment Types',
    description: 'Title of filter by categories',
  },
  titleTransactionSearch: {
    id: 'onboarding.title_transaction_search',
    defaultMessage: 'Transaction Search',
    description: 'Title of transactions search',
  },
  titleAddNotes: {
    id: 'onboarding.title_add_notes',
    defaultMessage: 'Add a note',
    description: 'Title of add notes',
  },
});
